var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          attrs: {
            name: _vm.modalName,
            height: "auto",
            classes: [
              "v--modal",
              "vue-dialog",
              "ccs--modal",
              "vue-dialog-borders",
              this.params.class
            ],
            width: _vm.width,
            "pivot-y": 0.3,
            adaptive: true,
            "click-to-close": _vm.clickToClose,
            transition: _vm.transition,
            scrollable: true,
            closeOnEnter: _vm.closeOnEnter,
            show_icon: _vm.show_icon,
            show_header: _vm.show_header,
            header_text: _vm.header_text
          },
          on: {
            "before-open": _vm.beforeOpened,
            "before-close": _vm.beforeClosed,
            opened: function($event) {
              return _vm.$emit("opened", $event)
            },
            closed: function($event) {
              return _vm.$emit("closed", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "dialog-content" },
            [
              _c("div", { staticClass: "c-box__header" }, [
                _vm.show_header
                  ? _c("h3", { staticClass: "c-box__title mb-5" }, [
                      _vm._v(_vm._s(_vm.header_text))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "dialog-c-close c-btn float-right",
                    on: {
                      click: function($event) {
                        return _vm.$modal.hide(_vm.modalName)
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "ccs-table__icon icon-delete-ccs icon-ccs"
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.show_icon
                ? _c("div", { staticClass: "icon-type" }, [
                    _vm.shouldShow("info")
                      ? _c(
                          "div",
                          { staticClass: "c-modal-icon c-modal-icon--info" },
                          [
                            _c("fa", {
                              attrs: { icon: ["far", "info-square"] }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.shouldShow("error")
                      ? _c(
                          "div",
                          { staticClass: "c-modal-icon c-modal-icon--error" },
                          [
                            _c("fa", {
                              attrs: { icon: ["far", "times-square"] }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.shouldShow("success")
                      ? _c(
                          "div",
                          { staticClass: "c-modal-icon c-modal-icon--success" },
                          [_c("fa", { attrs: { icon: ["fas", "check"] } })],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.shouldShow("warning")
                      ? _c(
                          "div",
                          { staticClass: "c-modal-icon c-modal-icon--warning" },
                          [
                            _c("fa", {
                              attrs: { icon: ["far", "exclamation-square"] }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.params.title
                ? _c("div", {
                    staticClass: "dialog-c-title",
                    domProps: { innerHTML: _vm._s(_vm.params.title) }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticClass: "dialog-c-text",
                domProps: { innerHTML: _vm._s(_vm.params.text || "") }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog-c-text" },
                [_vm._t("content")],
                2
              ),
              _vm._v(" "),
              _c(
                "b-alert",
                {
                  attrs: {
                    show: _vm.responseMessage.isVisible,
                    variant: _vm.responseMessage.type,
                    dismissible: "",
                    fade: ""
                  },
                  on: {
                    dismissed: function($event) {
                      _vm.responseMessage.isVisible = false
                    }
                  }
                },
                [
                  _c("h5", { staticClass: "alert-heading" }, [
                    _vm._v(_vm._s(_vm.responseMessage.title))
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.responseMessage.message) +
                      "\n            "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.show_buttons && _vm.buttons
            ? _c(
                "div",
                { staticClass: "vue-dialog-buttons" },
                _vm._l(_vm.buttons, function(button, i) {
                  return _c(
                    "button",
                    {
                      key: i,
                      class: button.class || "vue-dialog-button",
                      style: _vm.buttonStyle,
                      attrs: {
                        type: "button",
                        disabled: _vm.loadingRequest === true
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.click(i, $event)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.loadingRequest === true
                              ? "Loading..."
                              : button.title
                          ) +
                          "\n            "
                      )
                    ]
                  )
                }),
                0
              )
            : _c("div", { staticClass: "vue-dialog-buttons-none" })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }